import * as yup from 'yup';

import { formatMessage } from 'utils/messages/utils';

export default yup.object().shape({
  metric: yup.object().required(formatMessage('PLEASE_SELECT_A_METRIC')).nullable()
});
